import { render, staticRenderFns } from "./_template-jumbotron.vue?vue&type=template&id=1199b833&scoped=true&"
import script from "./_template-jumbotron.vue?vue&type=script&lang=js&"
export * from "./_template-jumbotron.vue?vue&type=script&lang=js&"
import style0 from "./_template-jumbotron.vue?vue&type=style&index=0&id=1199b833&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1199b833",
  null
  
)

export default component.exports